import {MqttDeviceConnectProvide} from "@hybird/device/protocol/mqtt";
import {xda} from "@hybird/flutter/bridge";
import {WebError} from "@hybird/core/error";
import {deviceError} from "@hybird/device/deviceError";
import {Buffer} from "buffer";

export class FlutterMqttDeviceConnectProvide extends MqttDeviceConnectProvide {

  clientId;

  _connected = false;

  async close(force = true) {
    this._end = true;
    this._connected = false;

    return new Promise((resolve, reject) => {
      xda.disconnectMqtt({clientId: this.clientId}).then(() => {
        resolve();
      }).catch(e => {
        reject(WebError.error(e, deviceError.CLOSE_ERROR));
      });
    });
  }

  async connectMqtt(connectForce = false, {
    onConnect, onConnected, onReconnect, onDisconnect, onDisconnected, onError, timeout = 10, config
  } = {}) {
    return new Promise((resolve, reject) => {
      if (config?.mqtt?.clientId) {
        this.clientId = config.mqtt.clientId;
      }

      this._getConnected().then(connected => {
        if (connected) {
          this._connected = true;
          resolve(this);
          return;
        }


        xda.connectMqtt({
          ...config.mqtt, url: config.mqtt.mqttUrl, onConnect, onConnected: () => {
            resolve(this);
            config?.onConnected?.call(this, this);
            onConnected?.call(this);
            this._connected = true;
          }, onReconnect: async () => {
            config?.onReconnect?.call(this, 1, this);
            onReconnect?.call(this);

            this._connected = await this._getConnected();
          }, onDisconnected: () => {
            this._connected = false;

            if (this._connectForce && !this._end) {
              config?.onReconnect?.call(this, 2, this);
              this.connectMqtt(connectForce, {config}).then((client) => {
                resolve(this);
              });
            } else {
              reject(WebError.code(deviceError.CONNECT_ERROR, {}));
            }
            onDisconnected?.call(this);
          },
          onMessage: ({payload, topic}) => {
            const replyData = Buffer.from(payload, "hex").toString();
            console.log("message", topic, replyData);
            this._onMessage(topic, JSON.parse(replyData));
          }
        }).then(data => {
          if (data === "connected") {
            resolve(this);
          }
        }).catch(e => {
          reject(WebError.error(e, deviceError.CONNECT_ERROR));
        });
      }).catch(e => {
        reject(WebError.error(e, deviceError.CONNECT_ERROR));
      });
    })
  }

  get connected() {
    return this._connected;
  }

  async _getConnected() {
    const state = await xda.getMqttState({clientId: this.clientId});

    return state.connected === "connected";
  }

  async _subscribe(topic, {success, message, complete, fail} = {}) {
    if (!topic.startsWith("/")) {
      console.warn("topic 地址不对", topic);
      throw WebError.code(deviceError.SUBSCRIBE_ERROR);
    }

    await xda.subscribeMqtt({clientId: this.clientId, topic});
  }


  async _publish(topic, params, {id, success, complete, fail} = {}) {
    const records = {
      id: id ? id : this.id, version: "1.0", params: params ?? {}, time: Date.now()
    };

    console.log(this.toString(), "publish", topic, JSON.stringify(records));
    await xda.publishMqtt({
      clientId: this.clientId,
      topic,
      payload: Buffer.from(JSON.stringify(records)).toString("hex")
    });
  }

  async _unsubscribe(topic, {success, error, complete, fail} = {}) {
    await xda.unsubscribeMqtt({clientId: this.clientId, topic});
  }
}